export function decodeHTMLEntities(str: string): string {
  // HTML 엔티티가 있는지 체크
  const hasEntities = /&(?:[a-zA-Z]+|#\d+|#x[0-9a-fA-F]+);/.test(str);
  if (!hasEntities) return str;

  // 브라우저 환경에서는 DOMParser 사용
  if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
    const parser = new DOMParser();
    const decoded = parser.parseFromString(str, 'text/html').body.textContent;
    return decoded || str;
  }

  // Node.js 환경에서는 그대로 반환
  return str;
}

export function formattingPhoneNumber(str: string): string {
  const sanitizedStr = str.replace(/[^0-9]/g, ''); // 숫자만 남기기

  if (sanitizedStr.length < 4) {
    return sanitizedStr;
  } else if (sanitizedStr.length < 8) {
    return sanitizedStr.replace(/(\d{3})(\d{1,4})/, '$1-$2');
  }
  return sanitizedStr.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3');
}
